module.exports = __webpack_public_path__ + "static/media/sym_bottom.2a3a7cf5.svg";